import React, { useMemo } from 'react';
import { HasPermissions, NotFound, Container, Main, FlexContainer } from '../../../components/common';
import { MediaListener } from '../../../components/utils';
import { AuditDateRangeContext } from '../../../components/contexts/AuditDateRange';
import AuditFilters from './auditFilters';
import AuditOrderCardList from './auditOrderCardList';
import AuditOrderDrawer from './auditOrderDrawer';
import { useAuditFilters } from '../hooks/useAuditFilters';
import { useAuditDrawer } from '../hooks/useAuditDrawer';
import { useAuditTitle } from '../hooks/useAuditTitle';
import { useAuditData } from '../hooks/useAuditData';

const AuditMonitorPage = ({ session, userInfo }) => {
    const {
        onSubmitFilters,
        getQueryFilters
    } = useAuditFilters(session);

    const {
        drawerOpened,
        selectedOrder,
        onClickCard,
        toggleDrawer
    } = useAuditDrawer();

    useAuditTitle();

    const queryFilters = useMemo(() => {
        return getQueryFilters();
    }, [getQueryFilters]);

    const { 
        groupedData, 
        hasData, 
        loading, 
        error,
        refetch
    } = useAuditData(queryFilters);

    return (
        <HasPermissions
            to={['audit-monitor:view']}
            otherwise={<NotFound firstTextLine='Página no encontrada' style={{ minHeight: '90vh' }} />}
        >
            <AuditDateRangeContext.Consumer>
                {({ setDate }) => (
                    <Container>
                        <Main background='f4f4f4' withFooter>
                            <HasPermissions to={['audit-monitor:filter&search']}>
                                <MediaListener values={['20%', '30%', '30%']}>
                                    {({ currentValue }) => (
                                        <AuditFilters
                                            currentValue={currentValue}
                                            onSubmitFilters={(values) => onSubmitFilters(values, setDate)}
                                        />
                                    )}
                                </MediaListener>
                            </HasPermissions>

                            <FlexContainer direction='column' shrink={0} grow={1}>
                                <AuditOrderCardList
                                    groupedData={groupedData}
                                    hasData={hasData}
                                    loading={loading}
                                    refetch={refetch}
                                    error={error}
                                    queryFilters={queryFilters}
                                    onOrderClick={onClickCard}
                                />
                            </FlexContainer>

                            <AuditOrderDrawer
                                visible={drawerOpened}
                                selectedOrder={selectedOrder}
                                userInfo={userInfo}
                                onClose={toggleDrawer}
                                refetch={refetch}
                                isAudit={true}
                            />
                        </Main>
                    </Container>
                )}
            </AuditDateRangeContext.Consumer>
        </HasPermissions>
    );
};

export default AuditMonitorPage;